import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router-dom';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { Loader } from '@components/loader';
import { GoBackHeader } from '@components/navigation/GoBackHeader';
import { RoutingTabs } from '@components/tab';
import { useGetWorkflow } from '@queryHooks/useWorkflow';
import type { WorkflowModel } from '@repositories/workflowRepository/models/WorkflowModel';
import { WorkflowDetailHeader } from './WorkflowDetailHeader';

export type WorkflowOutletContext = {
  workflow: WorkflowModel;
};

export const WorkflowDetail = observer(() => {
  const { workflowId } = useParams();
  const { t } = useTranslation();
  const { data: workflowDetail, isSuccess } = useGetWorkflow(workflowId ?? '');

  if (!isSuccess) return <Loader />;

  return (
    <Container>
      <GoBackHeader title={t('Workflow.menu.list')} />
      <Header>{workflowDetail && <WorkflowDetailHeader />}</Header>
      <RoutingTabs
        variant="contain"
        tabList={[
          { name: t('WorkflowDetail.tabs.overview'), path: '', replace: true },
          { name: t('WorkflowDetail.tabs.executions'), path: 'executions', replace: true },
        ]}
      />
      {isSuccess && <Outlet context={{ workflow: workflowDetail }} />}
    </Container>
  );
});

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 23px 32px 0px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 36px;
  padding: 0px 28px;
  margin-bottom: 10px;
`;
